import React from 'react'
import { toast } from 'react-toastify'
import { LoadingButton } from '@mui/lab'
import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton
} from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import DataApi from 'api/faber/DataApi'
import MenuClose from 'assets/icons/MenuClose.png'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import OrbitSession from 'hooks/useCookies'
import { FinanceTableRows } from 'types/api/faber/payment.type'
import { DataRolloverRows } from 'types/api/faber/subscription.type'
const ManualRolloverDialog = ({
  row,
  handleDialogClose,
  manualRolloverDialog,
  handleMenuClose
}: FaberManualRolloverDialogProps) => {
  const faberToken: string = OrbitSession.get('faberToken')
  const { mutate: executeManualRollover, isLoading: isRolloverLoading } =
    useMutation(DataApi.executeManualRollover, {
      onSuccess: () => {
        toast.success('Successfully roll over user ')
      },
      onError: () => {
        toast.error('Failed to roll over user')
      },
      onSettled: () => {
        handleDialogClose()
        handleMenuClose()
      }
    })

  return (
    <Dialog
      open={manualRolloverDialog}
      onClose={() => {
        handleDialogClose()
        handleMenuClose()
      }}
      fullWidth={true}
      maxWidth='sm'
    >
      <DialogTitle
        sx={{
          margin: '0',
          fontWeight: '700',
          color: 'black',
          fontSize: '21px',
          mt: '4px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Box>Manual Rollover</Box>
        <IconButton
          onClick={handleDialogClose}
          size='small'
          data-cy='closeDialogBtn'
          sx={{
            mr: '-10px',
            mt: '-10px'
          }}
        >
          <img
            style={{
              width: '20px',
              height: '20px'
            }}
            src={MenuClose}
          />
        </IconButton>
      </DialogTitle>
      <Divider sx={{ width: '100%' }} />
      <DialogContent>
        <DialogContentText sx={{ marginBottom: '0', marginLeft: '0' }}>
          <TextColorFontBody
            sx={{ fontSize: '18px', fontWeight: 500, color: '#253140' }}
          >
            User ID: {row.userID}
          </TextColorFontBody>
          <TextColorFontBody
            sx={{ fontSize: '18px', fontWeight: 500, color: '#253140' }}
          >
            First Name: {row.firstName}
          </TextColorFontBody>
          <TextColorFontBody
            sx={{ fontSize: '18px', fontWeight: 500, color: '#253140' }}
          >
            ICCID: {row.iccid}
          </TextColorFontBody>
        </DialogContentText>
        <Box
          sx={{
            width: '100%',
            justifyContent: 'center',
            display: 'flex',
            mt: 2
          }}
        >
          <LoadingButton
            loading={isRolloverLoading}
            loadingIndicator={'loading...'}
            variant='filled'
            onClick={() =>
              executeManualRollover({
                timeStamp: new Date(),
                iccid: row.iccid,
                faberToken: faberToken
              })
            }
          >
            Rollover user
          </LoadingButton>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export interface RolloverLogProps {
  transactionRows: FinanceTableRows[]
}

interface FaberManualRolloverDialogProps {
  handleDialogClose: () => void
  manualRolloverDialog: boolean
  handleMenuClose: (value: void) => void
  row: DataRolloverRows
}

export default ManualRolloverDialog
